import { useEffect } from 'react';

import { Button } from '@mui/material';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { getKitchenDispatchOrderById } from 'src/redux/slices/kitchen-dispatch-order';

import ErrorContent from 'src/components/error-content';
import { useSettingsContext } from 'src/components/settings';
import { LeftIcon } from 'src/components/carousel/arrow-icons';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import { LoadingScreen } from '../../../components/loading-screen';
import { useAppDispatcher, useAppSelector } from '../../../redux/store';
import KitchenDispatchNewEditForm from '../kitchen-dispatch-new-edit-form';

type Props = {
  id: string;
};

export default function KitchenDispatchOrderEditView({ id }: Props) {
  const { item, status, error } = useAppSelector((state) => state.kitchenDispatchOrders);

  const settings = useSettingsContext();
  const dispatch = useAppDispatcher();

  useEffect(() => {
    dispatch(getKitchenDispatchOrderById({ itemID: id }));
  }, [dispatch, id]);

  if (status === 'loading' || status === 'idle') {
    return <LoadingScreen />;
  }

  if (status === 'failure') {
    return (
      <ErrorContent
        filled
        title="Failed to load dispatch order details"
        description={error}
        action={
          <Button
            component={RouterLink}
            href={paths.dashboard.kitchen.dispatch.root()}
            variant="contained"
            startIcon={<LeftIcon />}
          >
            Back to Dispatch Orders
          </Button>
        }
        sx={{
          py: 10,
        }}
      />
    );
  }

  if (status === 'success' && item) {
    return (
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading="Edit Dispatch Order"
          links={[
            {
              name: 'Dispatch Orders',
              href: paths.dashboard.kitchen.dispatch.root(),
            },
            { name: 'Edit Dispatch Order' },
          ]}
          sx={{
            mb: { xs: 3, md: 5 },
          }}
        />

        <KitchenDispatchNewEditForm currentKitchenDispatchItem={item} />
      </Container>
    );
  }

  return <span />;
}
